/*
  expandAllNodes.js
*/

/**
 * Helper to expand all nodes within graphData. Returns modified graphData.
 */
export default function expandAllNodes(graphData) {

  // Get all node replacements.
  const replaceNodes = new Map();
  for (const node of graphData.nodes) {
    if (node._botech?.collapsed) {
      const next = { ...node, _botech: { ...node._botech }};
      delete next._botech.collapsed;
      replaceNodes.set(node, next);
    }
  }

  // If there are no replacements, no update is required.
  if (replaceNodes.size === 0) {
    return graphData;
  }

  // Update graph data.
  return {
    ...graphData,
    nodes: graphData.nodes.map(obj => replaceNodes.get(obj) || obj),
    links: graphData.links.map(obj => replaceNodes.has(obj.source) || replaceNodes.has(obj.target) ? {
      ...obj,
      source: replaceNodes.get(obj.source) || obj.source,
      target: replaceNodes.get(obj.target) || obj.target,
    } : obj),
  };
}
